/* eslint @typescript-eslint/camelcase: 0 */

import {HcmRouteConfig} from "@/router";
import TerminalImplementationList from "@/components/pages/implementation/TerminalImplementationList/index.vue";
import TerminalImplementationList_ControllerListTab from "@/components/pages/implementation/TerminalImplementationList/ControllerListTab.vue";
import TerminalImplementationList_CalendarListTab from "@/components/pages/implementation/TerminalImplementationList/CalendarListTab.vue";
import ControllerShow from "@/components/pages/implementation/ControllerShow/index.vue";
import DataImplementationList from "@/components/pages/implementation/DataImplementationList/index.vue";
import DataImplementationShow from "@/components/pages/implementation/DataImplementationShow/index.vue";
import ServiceImplementationList from "@/components/pages/implementation/ServiceImplementationList/index.vue";
import ServiceImplementationShow from "@/components/pages/implementation/ServiceImplementationShow/index.vue";

const routes: HcmRouteConfig[] = [
  /********************************************************************************************************************
   * 実装管理
   ********************************************************************************************************************/

  // サイト実装管理
  {
    path: '/browse/list/terminalImplementation',
    name: '/browse/list/terminalImplementation/TerminalImplementationList',
    component: TerminalImplementationList,
    meta: {
      label: 'サイト実装管理',
      parent: 'Home',
      permissions: ['!implementation'],
      fallback: '/edit/list/terminalImplementation/TerminalImplementationList',
    },
    children: [{
      path: 'controllers',
      name: '/browse/list/terminalImplementation/TerminalImplementationList/controllers',
      component: TerminalImplementationList_ControllerListTab
    }, {
      path: 'calendars',
      name: '/browse/list/terminalImplementation/TerminalImplementationList/calendars',
      component: TerminalImplementationList_CalendarListTab
    }]
  }, {
    path: '/edit/list/terminalImplementation',
    name: '/edit/list/terminalImplementation/TerminalImplementationList',
    component: TerminalImplementationList,
    meta: {
      label: 'サイト実装管理',
      parent: 'Home',
      permissions: ['implementation'],
      fallback: '/browse/list/terminalImplementation/TerminalImplementationList',
    },
    children: [{
      path: 'controllers',
      name: '/edit/list/terminalImplementation/TerminalImplementationList/controllers',
      component: TerminalImplementationList_ControllerListTab
    }, {
      path: 'calendars',
      name: '/edit/list/terminalImplementation/TerminalImplementationList/calendars',
      component: TerminalImplementationList_CalendarListTab
    }]
  },

  // サイト実装管理 / コントローラ管理
  {
    path: '/browse/list/terminalImplementation/controllers/:controllerId',
    name: '/browse/list/terminalImplementation/TerminalImplementationList/controllers/ControllerShow',
    component: ControllerShow,
    props: true,
    meta: {
      label: 'コントローラ管理',
      parent: '/browse/list/terminalImplementation/TerminalImplementationList/controllers',
      permissions: ['!implementation'],
      fallback: '/edit/list/terminalImplementation/TerminalImplementationList/controllers/ControllerShow',
    }
  }, {
    path: '/edit/list/terminalImplementation/controllers/:controllerId',
    name: '/edit/list/terminalImplementation/TerminalImplementationList/controllers/ControllerShow',
    component: ControllerShow,
    props: true,
    meta: {
      label: 'コントローラ管理',
      parent: '/edit/list/terminalImplementation/TerminalImplementationList/controllers',
      permissions: ['implementation'],
      fallback: '/browse/list/terminalImplementation/TerminalImplementationList/controllers/ControllerShow',
    }
  },


  // データ実装管理
  {
    path: '/browse/list/dataImplementation',
    name: '/browse/list/dataImplementation/DataImplementationList',
    component: DataImplementationList,
    meta: {
      label: 'データ実装管理',
      parent: 'Home',
      permissions: ['!implementation'],
      fallback: '/edit/list/dataImplementation/DataImplementationList',
    }
  }, {
    path: '/edit/list/dataImplementation',
    name: '/edit/list/dataImplementation/DataImplementationList',
    component: DataImplementationList,
    meta: {
      label: 'データ実装管理',
      parent: 'Home',
      permissions: ['implementation'],
      fallback: '/browse/list/dataImplementation/DataImplementationList',
    }
  },
  // データ実装管理 / データ実装
  {
    path: '/browse/list/dataImplementation/:dataImplementationId',
    name: '/browse/list/dataImplementation/DataImplementationShow',
    component: DataImplementationShow,
    props: true,
    meta: {
      label: 'データ実装',
      parent: '/browse/list/dataImplementation/DataImplementationList',
      permissions: ['!implementation'],
      fallback: '/edit/list/dataImplementation/DataImplementationShow',
    }
  }, {
    path: '/edit/list/dataImplementation/:dataImplementationId',
    name: '/edit/list/dataImplementation/DataImplementationShow',
    component: DataImplementationShow,
    props: true,
    meta: {
      label: 'データ実装',
      parent: '/edit/list/dataImplementation/DataImplementationList',
      permissions: ['implementation'],
      fallback: '/browse/list/dataImplementation/DataImplementationShow',
    }
  },


  // サービス実装管理
  {
    path: '/browse/list/serviceImplementation',
    name: '/browse/list/serviceImplementation/ServiceImplementationList',
    component: ServiceImplementationList,
    meta: {
      label: 'サービス実装管理',
      parent: 'Home',
      permissions: ['!implementation'],
      fallback: '/edit/list/serviceImplementation/ServiceImplementationList',
    }
  }, {
    path: '/edit/list/serviceImplementation',
    name: '/edit/list/serviceImplementation/ServiceImplementationList',
    component: ServiceImplementationList,
    meta: {
      label: 'サービス実装管理',
      parent: 'Home',
      permissions: ['implementation'],
      fallback: '/browse/list/serviceImplementation/ServiceImplementationList',
    }
  },
  // サービス実装管理 / サービス実装
  {
    path: '/browse/list/serviceImplementation/:serviceImplementationId',
    name: '/browse/list/serviceImplementation/ServiceImplementationShow',
    component: ServiceImplementationShow,
    props: true,
    meta: {
      label: 'サービス実装',
      parent: '/browse/list/serviceImplementation/ServiceImplementationList',
      permissions: ['!implementation'],
      fallback: '/edit/list/serviceImplementation/ServiceImplementationShow',
    }
  }, {
    path: '/edit/list/serviceImplementation/:serviceImplementationId',
    name: '/edit/list/serviceImplementation/ServiceImplementationShow',
    component: ServiceImplementationShow,
    props: true,
    meta: {
      label: 'サービス実装',
      parent: '/edit/list/serviceImplementation/ServiceImplementationList',
      permissions: ['implementation'],
      fallback: '/browse/list/serviceImplementation/ServiceImplementationShow',
    }
  },
];

export default routes;
